import type { JeevesPricingType } from '@/lib/services/Jeeves/pricing/getProductPricing'
import type { CustomerType } from '@/store/types/user'
import useGlobalStore from '@/store/useGlobalStore'
import { getTerms } from '../services/useGetTerms'
import { usePriceHandler } from './usePriceHandler'

export const useGetCustomerProductPricing = () => {
  const {
    app: { marketExceptions },
  } = useGlobalStore()
  const { priceHandler } = usePriceHandler()

  const displayPrice = ({
    forCustomerType,
    pricingData,
  }: {
    forCustomerType: CustomerType
    pricingData: JeevesPricingType | null
  }): string => {
    const terms = getTerms({ forCustomerType, pricingData })

    // Last resort error handling, we should never see this
    // If there's an error the app wont' even display purchase options
    if (!terms?.priceEach) return 'N/A'

    return priceHandler({
      forCustomerType,
      pricingData,
      currency: marketExceptions?.currencyCode,
    }).toString()
  }

  return { getTerms, displayPrice }
}
